import React from 'react';

export default React.createContext({ uploads: [] });
//# sourceMappingURL=EditorContext.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DraftEditor/EditorContext.js
// module id = 995
// module chunks = 0